import React, { useEffect } from 'react';
import { Row, Col, Select, Tooltip } from 'antd';
import styled from 'styled-components';

import WorkOrderStore from 'stores/WorkOrderStore';

import { Container, StyledSelect } from './common';

import { tooltipText } from 'helpers/HelperFunctions';

const { Option } = Select;

function VMRSAsyCode(props) {
  const { title, vmrs_sys_code, vmrs_asm_code, changeItemProperty, itemKey } =
    props;

  const [asyCodes, setAsyCodes] = React.useState([]);
  const [filteredCodes, setFilteredCodes] = React.useState([]);

  useEffect(() => {
    async function fetchVMRSAsyCodes() {
      if (!vmrs_sys_code) return;

      const data = await WorkOrderStore.getVMRSAsyCodes(vmrs_sys_code);
      setAsyCodes(data);
      setFilteredCodes(data);
    }
    fetchVMRSAsyCodes();
  }, [vmrs_sys_code]);

  const options = filteredCodes.map((item) => ({
    value: item.asy,
    label: (
      <span>
        {String(item.asy).padStart(3, '0')}{' '}
        <span className="certain-search-item-count">{item.description}</span>
      </span>
    ),
  }));

  const searchHandler = (value) => {
    const filtered = asyCodes.filter((item) =>
      (
        String(item.asy).padStart(3, '0') +
        ' ' +
        item.description?.toLowerCase()
      ).includes(value.toLowerCase())
    );

    setFilteredCodes(filtered);
  };

  const handleChange = (value) => {
    const asyCode = asyCodes.find((d) => d.asy === value);

    changeItemProperty(itemKey, 'vmrs_asm_code_id', null);
    changeItemProperty(
      itemKey,
      'vmrs_asm_code',
      String(asyCode.asy).padStart(3, '0')
    );
    changeItemProperty(itemKey, 'vmrs_asm_text', asyCode.description);

    changeItemProperty(itemKey, 'vmrs_comp_code_id', null);
    changeItemProperty(itemKey, 'vmrs_comp_code', null);
    changeItemProperty(itemKey, 'vmrs_comp_text', null);

    changeItemProperty(itemKey, 'vmrs_full_code', '');
    changeItemProperty(itemKey, 'vmrs_full_description', '');
  };

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>{title}</Col>
      </Row>
      <Row>
        <Col span={24}>
          <Tooltip title={tooltipText(vmrs_asm_code)}>
            <StyledSelect
              showSearch
              onSearch={searchHandler}
              value={vmrs_asm_code == null ? '' : Number(vmrs_asm_code)}
              style={{ width: '100%' }}
              onChange={handleChange}
              filterOption={false}
              data-testid="vmrs-assembly-code-select"
              options={options}
            />
          </Tooltip>
        </Col>
      </Row>
    </Container>
  );
}

export default VMRSAsyCode;
